import type { PriceVO } from '@ctct/domain-layer';

import { controllerHelpers, type Listeners } from '../helpers';
import type { PrepaySelectManager } from '../managers';
import { orderSummaryEventBus } from '../managers';

export class PrepayController {
  public listeners: Listeners;

  constructor(private prepaySelectManager: PrepaySelectManager) {
    this.listeners = controllerHelpers.createListeners([
      orderSummaryEventBus.bindTo('planBaseMonthlyPriceUpdated', this.onPlanBaseMonthlyPriceUpdated),
    ]);
  }

  private onPlanBaseMonthlyPriceUpdated = async (planBaseMonthlyPrice: { value: PriceVO; currency: string }) => {
    const api = await this.prepaySelectManager.getApiWhenReady();

    api.setPlanBaseMonthlyPrice(planBaseMonthlyPrice);
  };
}
